"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.progressionComplete = exports.progressionFail = exports.progressionStart = exports.init = exports.disable = exports.callAnalytics = exports.exists = void 0;
var namespace = 'analytics';
var exists = function () {
    if (typeof GameAnalytics !== 'undefined') {
        return true;
    }
    return false;
};
exports.exists = exists;
var callAnalytics = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    if (typeof GameAnalytics !== 'undefined') {
        GameAnalytics.apply(void 0, __spreadArray([], __read(args), false));
    }
};
exports.callAnalytics = callAnalytics;
// see: https://docs.gameanalytics.com/integrations/sdk/javascript
var disable = function () {
    if (!(0, exports.exists)()) {
        return;
    }
    (0, exports.callAnalytics)('setEnabledEventSubmission', false);
};
exports.disable = disable;
var init = function (build, gameKey, gameSecretKey) {
    if (!(0, exports.exists)()) {
        return;
    }
    console.log(namespace, 'init', build);
    (0, exports.callAnalytics)('setEnabledInfoLog', true);
    (0, exports.callAnalytics)('setEnabledVerboseLog', true);
    (0, exports.callAnalytics)('configureBuild', build);
    (0, exports.callAnalytics)('initialize', gameKey, gameSecretKey);
    // GameAnalytics.configureAvailableResourceCurrencies(["gems", "gold"]);
    // GameAnalytics.configureAvailableResourceItemTypes(["boost", "lives"]);
    // GameAnalytics.configureAvailableCustomDimensions01(["ninja", "samurai"]);
    // GameAnalytics.configureAvailableCustomDimensions02(["whale", "dolphin"]);
    // GameAnalytics.configureAvailableCustomDimensions03(["horde", "alliance"]);
};
exports.init = init;
var progressionStart = function (level) {
    if (!(0, exports.exists)()) {
        return;
    }
    console.log(namespace, 'progressionStart', level);
    (0, exports.callAnalytics)('addProgressionEvent', 'Start', level);
};
exports.progressionStart = progressionStart;
var progressionFail = function (level) {
    if (!(0, exports.exists)()) {
        return;
    }
    (0, exports.callAnalytics)('addProgressionEvent', 'Fail', level);
};
exports.progressionFail = progressionFail;
var progressionComplete = function (level) {
    if (!(0, exports.exists)()) {
        return;
    }
    (0, exports.callAnalytics)('addProgressionEvent', 'Complete', level);
};
exports.progressionComplete = progressionComplete;
